import React from 'react';
import PropTypes from "prop-types";
import ReactDOM from 'react-dom';

import { FaPlay, FaPause } from 'react-icons/fa';

class ReplayView extends React.Component {

    genPlayButton() {
        if (!this.props.isPaused)
        {
            return (
                <FaPause/>
            );
        }
        else
        {
            return (
                <FaPlay/>
            );
        }
    }

	render() {

        var r = (0.1 + this.props.playAmt * 0.8) * Math.min(this.props.maxWidth, window.innerWidth) - 16;

        return (
            <div class="main2" id="main">
                <div class="returnToMainMenu" onClick={this.props.returnToMainMenu}>
                    { this.props.backButtonText }
                </div>

                <div class="playbutton" onClick={this.props.clickPlay}>
                    { this.genPlayButton() }
                </div>

                <div class="scrubber" onDrag={this.props.clickScrubber} onClick={this.props.clickScrubber}>
                </div>
                
                <div style={{ left: r }} onDrag={this.props.clickScrubber} class="playPosition" onClick={this.props.clickScrubber}>
                </div>

                <div class="shareThis">
                    share: <a href={this.props.baseURL + this.props.shareLink} target="_blank">{this.props.baseURL + this.props.shareLink}</a>
                    <br/>
                </div>
            </div>
        );
	}
}

ReplayView.propTypes = {
    
    baseURL:  PropTypes.string, 
  backButtonText: PropTypes.string,  
  shareLink: PropTypes.string,

  isPaused: PropTypes.bool,
  playAmt: PropTypes.number,
  maxWidth: PropTypes.number,

  returnToMainMenu: PropTypes.func,
  clickPlay: PropTypes.func,
  clickScrubber: PropTypes.func,
};

export default ReplayView;